import React from "react";
import styles from "./AboutHero1.module.css";

/* ── Data ─────────────────────────────────────── */
const HEADLINE = ["FULL-STACK", "DRONE", "ENGINEERING."];
const SECTORS = ["Agriculture", "Mapping", "Inspection", "FPV", "Enterprise"];

const TICKER_ITEMS = [
    "Full-Stack UAV Manufacturing",
    "Made in India",
    "Agriculture",
    "Mapping",
    "Inspection",
    "FPV Racing",
    "Enterprise Operations",
    "Aeronautical Design",
    "Embedded Hardware",
    "Custom Firmware",
];

/* ── Component ────────────────────────────────── */
export default function AviatricsHero() {
    return (
        <>
            {/* Film grain */}
            <div className={styles.grain} aria-hidden="true" />

            {/* ── HERO ─────────────────────────────── */}
            <section className={styles.hero}>

                {/* Top purple accent line */}
                <div className={styles.heroAccentLine} aria-hidden="true" />

                {/* Main two-column body */}
                <div className={styles.heroInner}>

                    {/* LEFT — Text */}
                    <div className={styles.heroText}>

                        {/* Eyebrow */}
                        <div className={styles.eyebrow}>
                            <span className={styles.eyebrowTick} />
                            <span className={styles.eyebrowLabel}>End-to-End UAV Manufacturing</span>
                        </div>

                        {/* Headline — each line clips up individually */}
                        <h1 className={styles.headline} aria-label="Full-Stack Drone Engineering">
                            {HEADLINE.map((line, i) => (
                                <span className={styles.hlRow} key={line}>
                                    <span
                                        className={styles.hlInner}
                                        style={{ "--d": `${0.38 + i * 0.18}s` }}
                                    >
                                        {line}
                                    </span>
                                </span>
                            ))}
                        </h1>

                        {/* Description */}
                        <p className={styles.heroDesc}>
                            Aviatricks is an indigenous UAV company integrating aeronautical
                            design, embedded hardware, and custom flight software under one
                            roof — delivering mission-ready drones for agriculture, mapping,
                            inspection, and enterprise operations.
                        </p>

                        {/* Sector chips */}
                        <div className={styles.sectorRow}>
                            {SECTORS.map((s, i) => (
                                <span
                                    key={s}
                                    className={styles.sectorChip}
                                    style={{ "--d": `${1.1 + i * 0.07}s` }}
                                >
                                    {s}
                                </span>
                            ))}
                        </div>

                        {/* CTA row */}
                        <div className={styles.ctaRow}>
                            <a href="#about" className={styles.ctaPrimary}>Explore Our Work →</a>
                            <a href="mailto:support@aviatricks.in" className={styles.ctaGhost}>
                                support@aviatricks.in
                            </a>
                        </div>
                    </div>

                    {/* RIGHT — Drone image */}
                    {/* Replace src with your Gemini-generated image e.g. src="/images/drone.png" */}
                    <div className={styles.heroVisual} aria-hidden="true">
                        <div className={styles.droneRing} />
                        <div className={styles.droneWrap}>
                            <img
                                src="/images/drone1.png"
                                alt="Aviatricks UAV Drone"
                                className={styles.droneImg}
                            />
                        </div>
                    </div>

                </div>

                {/* Scrolling ticker */}
                <div className={styles.tickerWrap} aria-hidden="true">
                    <div className={styles.tickerInner}>
                        {[...TICKER_ITEMS, ...TICKER_ITEMS].map((t, i) => (
                            <span className={styles.tickerText} key={i}>
                                {t} <span className={styles.tickerDot}>·</span>
                            </span>
                        ))}
                    </div>
                </div>

                {/* Footer bar */}
                <div className={styles.heroFoot}>
                    <div className={styles.hfootRule} />
                    <div className={styles.hfootRow}>
                        <span className={styles.hfootLeft}>www.aviatricks.in</span>
                        <span className={styles.hfootCenter}>Design · Hardware · Software · Deploy</span>
                        <span className={styles.hfootRight}>Indigenous UAV · Made in India</span>
                    </div>
                </div>

            </section>
        </>
    );
}